import Reflux from "reflux";
import Freezer from "freezer-js";
import _ from "lodash";

import CarouselActions from "../react_actions/carousel_actions";

import { computeTrackStyle, getStoreObjects } from "../modules/carousel/carousel_helper";

const defaultState = { carousels: {} };
const state = new Freezer(defaultState);

const resetTo = (data={}) => {
  getState().reset(_.merge({}, defaultState, data));
};

const getState = () => state.get();

const getStateForKey = (key) => {
  if (!_.has(getState().carousels, key) ) {
    throw new ReferenceError(`No such carousel existing for key ${  key}`);
  }
  return getState().carousels[key];
};

const setDataForKey = (key, data) => {
  getStateForKey(key).set(data);
};

export default Reflux.createStore({

  listenables: [CarouselActions],

  initializeWith(data) {
    resetTo(data);
  },

  updateWith(data) {
    getState().set(_.merge({}, getState(), data));
  },

  onSetSlides(carouselId) {
    const reactObjects = getStoreObjects(getStateForKey(carouselId));
    const newStateHash = {
      slideCount: getStateForKey(carouselId).slides.length,
      slides: reactObjects.slides,
    };
    if (reactObjects.tooltips) {
      newStateHash.tooltips = reactObjects.tooltips;
    }
    const newState = _.merge(newStateHash, getStateForKey(carouselId));
    if (!reactObjects.tooltips && newState.hasOwnProperty("tooltips")){
      newState.tooltips=undefined;
    }
    setDataForKey(carouselId, newState);
    this.notifyListeners();
  },

  onSetWidths(carouselId, data) {
    const newState = _.merge({}, getStateForKey(carouselId), data);
    setDataForKey(carouselId, newState);
    this.notifyListeners();
  },

  onSlidingCompletion(carouselId, targetSlide) {
    setDataForKey(carouselId, _.merge({}, getStateForKey(carouselId), { currentSlide: targetSlide }));
    this.notifyListeners();
  },

  onShowTooltip(carouselId, tooltipId) {
    setDataForKey(carouselId, _.merge({}, getStateForKey(carouselId), { displayTooltipAtIndex: tooltipId }));
    this.notifyListeners();
  },

  onHideTooltip(carouselId) {
    setDataForKey(carouselId, _.merge({}, getStateForKey(carouselId), { displayTooltipAtIndex: -1 }));
    this.notifyListeners();
  },

  getInitialState(key) {
    if (!_.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getInitialStateForKey: getStateForKey,

  getState,

  reset:resetTo,

  notifyListeners() {
    this.trigger(getState());
  },

});
